import React from "react";
import { TrackingLayer } from "./tracking-layer";
import { ZoneFilter } from "./zone-filter";
import { MapSettings } from "./map-settings";
import { MyLocationControl } from "./my-location";
import { Button } from "@/components/ui/button";
import { Plane } from "lucide-react";
import { FeatureFlags } from "@/feature_flags/feature_flag";
import { useFlag } from "@openfeature/react-sdk";

export const MapControls: React.FC = () => {
  const { value: isFlightPlanSubmissionEnabled } = useFlag(FeatureFlags.flight_plan_submission_enabled, false);

  const handleSubmitFlightPlan = () => {
    // TODO: Implement flight plan submission logic
  };

  return (
    <div className="absolute top-3 right-3 z-10 flex flex-col items-end space-y-3">
      <TrackingLayer />
      <ZoneFilter />
      <MyLocationControl />

      {/* Submit Flight Plan Button - Only shown when feature flag is enabled */}
      {isFlightPlanSubmissionEnabled && (
        <Button
          onClick={handleSubmitFlightPlan}
          className="bg-blue-600 hover:bg-blue-700 text-white shadow-lg"
          size="sm"
        >
          <Plane className="h-4 w-4 mr-2" />
          Submit Flight Plan
        </Button>
      )}

      {/* Map Settings */}
      <MapSettings />
    </div>
  );
};
